<template>
    <div class="container" v-if="mobile">
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col-md-12">
                        <form ref="form">
                            <input type="hidden" name="_token" :value="csrf">
                            <div class="row search-mobile">
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <br>
                                    <category-select 
                                        name="categoria" 
                                        selectname="categoria" 
                                        labelcolor="#FFFFFF" 
                                        :primarycolor="colors.primary" 
                                        required="true" 
                                        trackby="id" 
                                        :options="homepagedata.categorie" 
                                        placeholder="Cosa stai cercando ?" 
                                        @onChange="setCategoria($event)" 
                                        :style="inputRequired ? 'color:'+colors.primary+';border: '+colors.primary+' 1.2px solid;' : ''"
                                    ></category-select>
                                    <div :style="'color:'+colors.primary" class="border-0 text-left" v-show="inputRequired">Il campo Categoria è richiesto!</div>
                                </div>
                                <div class="search-mobile1 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <span style="font-size:30px;cursor:pointer" onclick="openNav()">
                                        <input id="open-mobile-form" class="form-control" readonly="" placeholder="Ricerca zone o comune">
                                    </span>
                                </div>
                                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div class="form-group">
                                        <button type="button" class="search-button" @click.prevent="submitData">Cerca subito</button>
                                    </div>
                                    <div class="motore" v-html="homepagedata.link_ricerca"></div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['colors', 'homepagedata', 'mobile'],
        data() {
            return {
                csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                formInputs:{
                    categoria: null
                },
                inputRequired: false,
            }
        },
        methods: {
            submitData(){
                if(this.formInputs.categoria!==null){
                    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = this.csrf;
                    window.axios.post(process.env.MIX_BASE_URL+'ricerca/quick-url-generate', this.formInputs)
                        .then(res => {
                            window.location.href = res.data.data.redirectsTo;
                        })
                        .catch(err => {
                            Swal.fire({
                                text: 'Ops! Qualcosa è andato storto, per favore prova di nuovo.',
                                type: 'error'
                            })
                        });
                }
                else {
                    this.inputRequired = true;
                }
            },
            setCategoria(selected){
                if (selected){
                    this.formInputs.categoria = selected.id;
                    this.inputRequired = false;
                }
                this.$emit('categoriaChanged', selected);
            },
        },
        mounted() {},
    }
</script>

<style lang="scss" scoped>
    .draw-mobile-btn {
        width: 100%;
        height: 40px;
    }
    .is-invalid {
        color: #dc3545;
        border: #dc3545 1.2px solid;
    }
</style>
